import React from "react";
import "../css/projects.css";

const Projects = () => {
    return (
        <div className="projects-container">
            <div className="projects-sub-container">
                <div className="project-section">
                    <a
                        href="https://github.com/dvholmes/twitter_bot/tree/main/mlbpredictor"
                        className="project-title"
                        target="_blank"
                        rel="noreferrer"
                    >
                        MLB Game Predictor
                    </a>
                    <img src="MLBLogo.png" alt="MLB Logo" />
                    <p className="project-description">
                        Developed a machine learning model to predict daily MLB game outcomes with 80% accuracy. The model incorporates a
                        wide range of team performance indicators including OPS, ERA, OBP, win/loss streaks, home vs. away status, and other
                        advanced sabermetrics to forecast whether a team would win or lose on a given day.
                        <br />
                        <br />
                        Built a comprehensive dataset using the Sports-API Reference and BeautifulSoup to automate web scraping of
                        historical game results and statistical metrics. Implemented a RandomForestClassifier from Scikit-learn with 100
                        estimators, integrating data scraping, preprocessing, and supervised learning into a full pipeline for real-world
                        predictive modeling.
                    </p>
                </div>

                <div className="project-section">
                    <a
                        href="https://github.com/responsible-ai-collaborative/aiid"
                        className="project-title"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Deepfake Political Database
                    </a>
                    <img src="diidlogo.png" alt="Deepfake Incident DB Logo" />
                    <p className="project-description">
                        Built a statically generated web application to catalog and contextualize politically charged deepfake incidents
                        worldwide. Using React.js, MongoDB, and Cloudinary, the platform serves as a structured, searchable archive with a
                        custom taxonomy system that tags each incident by country of origin, manipulation type, media format, and
                        verification status.
                        <br />
                        <br />
                        Developed an automated verification pipeline that cross-references entries against trusted fact-checking sources to
                        maintain data integrity. Collaborated with senior engineers and ethical AI researchers from the Responsible AI
                        Collaborative to shape the project's ethical framework for handling and presenting misinformation data responsibly.
                    </p>
                </div>

                <div className="project-section">
                    <a href="https://github.com/dvholmes/officalHolmesEnviro" className="project-title" target="_blank" rel="noreferrer">
                        Holmes Enviro Website
                    </a>
                    <img src="holmesenviro.png" alt="Holmes Enviro Logo" />
                    <p className="project-description">
                        Led the end-to-end design and development of a fully responsive website for Holmes Enviro, a company specializing in
                        environmental solutions. Built with React.js on the frontend, the site delivers a seamless experience across
                        desktop, tablet, and mobile, giving customers easy access to products, pricing, and contact information.
                        <br />
                        <br />
                        Implemented a lightweight Node.js backend to handle inquiries and product updates, and integrated Google Firebase
                        for cloud hosting, user authentication, and database management. The final platform elevated the company's digital
                        presence and streamlined customer communication through a clean, mobile-first design.
                    </p>
                </div>

                <div className="project-section">
                    <a href="https://github.com/dvholmes/twitter_bot" className="project-title" target="_blank" rel="noreferrer">
                        Twitter Bot
                    </a>
                    <img src="botlogo.png" alt="Twitter Bot Logo" />
                    <p className="project-description">
                        Developed a fully automated Twitter bot that manages and posts content on a scheduled basis without manual input.
                        The system integrates four content modules — a Stock Market Predictor, Weather Analyzer, MLB Game Predictor, and
                        Famous Quotes Web Scraper — each providing a distinct stream of timely, relevant content.
                        <br />
                        <br />
                        Built with modularity and scalability in mind, the bot assembles content from each module, formats it into engaging
                        posts, and publishes them at predefined intervals throughout the day. This project demonstrates my ability to
                        integrate multiple APIs, automate multi-source content workflows, and build robust systems that deliver consistent
                        value at scale.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default Projects;
